import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M12 6a6 6 0 00-6 6.06v1.23a8.34 8.34 0 002.54 5.79l-1.71.37c-4 1-4.83 3-4.83 5.41V28a2 2 0 002 2h16a2 2 0 002-2v-3.14c0-2.39-.79-4.45-4.83-5.41l-1.77-.34a8.4 8.4 0 002.6-5.82v-1.23A6 6 0 0012 6z"/><path d="M25.17 18l-1.77-.35a8.88 8.88 0 002.6-6v-1.23A6.46 6.46 0 0019.5 4a6.53 6.53 0 00-3.56 1A8.07 8.07 0 0120 12v1.23a10 10 0 01-1.18 4.55C22.3 19 24 21.31 24 24.86V28a3.91 3.91 0 01-.56 2H28a2.15 2.15 0 002-2v-4.34c0-2.48-.79-4.66-4.83-5.66z"/>';
export var TeamSVG = function TeamSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TeamSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TeamSVG);